// extracted by mini-css-extract-plugin
export default {"leaveTable":"ActivityLogTable_leaveTable__5lgRY","customSharedBtn":"ActivityLogTable_customSharedBtn__cz6fi","customCloseIcon":"ActivityLogTable_customCloseIcon__wStVf"};